export default {
  title: 'Your provider handles this step',
  description: {
    payments: 'Contact {{partner}} to set up online payments.',
    go_live: 'Contact {{partner}} to take your restaurant live.',
  },
  fallback_partner: 'your provider',
};
